export enum ModalIDs {
  ConfirmDeletionModal = 'ConfirmDeletionModal',
  UpdateGroupDialog = 'UpdateGroupDialog',
  UpdateRuleDialog = 'UpdateRuleDialog',
  UpdateValueDialog = 'UpdateValueDialog',
  CreateGroupDialog = 'CreateGroupDialog',
  CreateRuleDialog = 'CreateRuleDialog',
  CreateValueDialog = 'CreateValueDialog',
  UpdatePartnerDialog = 'UpdatePartnerDialog',
  EditLink = 'EditLinkDialog',
  SelectImage = 'SelectImageDialog',
}
